import { createContext, useState, useEffect } from 'react'

export const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const saved = localStorage.getItem('gm_session')
    if (saved) {
      try {
        const s = JSON.parse(saved)
        // Quick verify with server
        fetch('/api/auth/verify', {
          headers: { Authorization: 'Bearer ' + s.token }
        }).then(r => r.json()).then(d => {
          if (d.valid) setUser(s.user)
          else localStorage.removeItem('gm_session')
        }).catch(() => {
          // Offline — trust local session
          setUser(s.user)
        }).finally(() => setIsLoading(false))
      } catch {
        localStorage.removeItem('gm_session')
        setIsLoading(false)
      }
    } else {
      setIsLoading(false)
    }
  }, [])

  const login = async (email, password) => {
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      })
      const data = await res.json()
      if (res.ok && data.success) {
        setUser(data.user)
        localStorage.setItem('gm_session', JSON.stringify({ user: data.user, token: data.token }))
        return { success: true }
      }
      return { success: false, error: data.error || 'Credenciales incorrectas' }
    } catch {
      return { success: false, error: 'Error de conexión con el servidor' }
    }
  }

  const logout = () => {
    setUser(null)
    localStorage.removeItem('gm_session')
  }

  const getToken = () => {
    try { return JSON.parse(localStorage.getItem('gm_session') || '{}').token || '' }
    catch { return '' }
  }

  return (
    <AuthContext.Provider value={{ user, isLoading, login, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  )
}
